import Api from '../api';

const { axios: api } = Api;

export const getCommon = async () => {
	const data = await api.get('/common-data');

	return data.data;
};
